@if (target$ | async; as target) {
    <button class="sh-pure-icon-button" type="button" [attr.aria-label]="target.label.key | translate: target.label.params" (click)="download(target)">
        <svg sh-icon class="sh-icon sh-icon-button__icon" name="download"></svg>
    </button>
}
